import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListingComponent } from './listing/listing.component';
//import { MasterLayoutComponent } from '../mnt-master/master-layout/master-layout.component'
import { OrderQueueComponent } from './order-queue/order-queue.component';
import { CustomeLineitemListComponent } from './custome-lineitem-list/custome-lineitem-list.component';
import { AddProductComponent } from './add-product/add-product.component';
import { CustomListingComponent } from './custom-listing/custom-listing.component';
import { SanmarListingComponent } from './sanmar-listing/sanmar-listing.component';
import { AlphabroderListingComponent } from './alphabroder-listing/alphabroder-listing.component';
import { AddSizeComponent } from './add-size/add-size.component';
import { QuickItemsComponent } from './quick-items/quick-items.component';
import { EditQuickItemComponent } from './edit-quick-item/edit-quick-item.component';


const routes: Routes = [
  {
    path: 'listing', component: ListingComponent   
  },
  {
    path: 'order-queue', component: OrderQueueComponent   
  },
  {
    path: 'cusotme-lineitem', component: CustomeLineitemListComponent    
  },
  {
    path: 'add-product', component: AddProductComponent    
  },
  {
    path: 'custom-listing', component: CustomListingComponent    
  },
  {
    path: 'sanmar-listing', component: SanmarListingComponent    
  },
  {
    path: 'alphabroder-listing', component: AlphabroderListingComponent    
  },
  {
    path: 'add-product/:productId', component: AddProductComponent    
  },
  {
    path: 'size', component: AddSizeComponent    
  },
  {
    path: 'quick-items', component: QuickItemsComponent    
  },
  {
    path: 'edit-quick-item/:productId', component: EditQuickItemComponent    
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MntProductsRoutingModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/mnt-products-routing.module.ts